import { services as auth } from '../endPoints'

export default {
    auth
}